module.exports = __webpack_public_path__ + "static/bsas013-6ecbb53325cb151fa9c2c6a9ffe5822b.jpg";